import "./xpressContainer.css";
import { CgCalendarDates } from "react-icons/cg";

const XpressContainer = ({ totalOrders, date, handleDateChange, setSearchOrderID }) => {
  return (
      <div className="xpressSection">
    <label className="calender">
      <CgCalendarDates size={22} color="#FFFFFF" />
      <input
        type="date"
        id="start"
        name="trip-start"
        value={date}
        onChange={handleDateChange}
        className="dateInput"
      />
    </label>
  <label className="xpressTotalOrderCount">
    Total Orders - {totalOrders}
  </label>
  <div className="flex-grow-1 mx-3 mt-1">
    <input
      type="text"
      className="form-control"
      placeholder="Search Order ID"
      onChange={(e) => {
        setSearchOrderID(e.target.value);
      }}
    />
  </div>
  <label className="stockCheck">Stock Check</label>
  </div>
  );
};

export default XpressContainer;
